export default __webpack_public_path__ + "static/media/elevate-cbb-banner-2.90f93cdc.jpg";